<template>
  <div></div>
</template>

<script>
export default {
  name: 'AppsIndex'
}
</script>

<style scoped>

</style>
